import {
    SET_LOADING,
    SET_USER_KYC_LIST,
    SET_USER_KYC_LIST_META,
    // SET_ARTIST_IMAGES,
} from "../../actions/kyc/types";

const INITIAL_STATE = {
    loading: false,
    userKycList: [],
    userKycListMetaData: null,
    selectedArtistImages: [],
}

const KycReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_USER_KYC_LIST: {
            return {
                ...state,
                userKycList : action.payload
            }
        }
        case SET_USER_KYC_LIST_META: {
            return {
                ...state,
                userKycListMetaData : action.payload
            }
        }
        // case SET_ARTIST_IMAGES: {
        //     return {
        //         ...state,
        //         selectedArtistImages : action.payload
        //     }
        // }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default KycReducer;
